<template>
  <Splide ref="splideRef" :options="slideOptions">
    <SplideSlide v-for="image in homeContentStore.contents.banners" :key="image.id">
      <img :src="image.banner" :alt="image.projectName" />
      <section class="elementor-section elementor-top-section elementor-element elementor-element-5174a02 elementor-section-height-min-height elementor-section-items-stretch elementor-section-content-bottom elementor-section-boxed elementor-section-height-default" data-id="5174a02" data-element_type="section" data-e-type="section" data-settings="{'background_background':'classic'}">
        <div  class="elementor-container elementor-column-gap-no">
          <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-4596ae5" data-id="4596ae5" data-element_type="column" data-e-type="column">
            <div class="elementor-widget-wrap elementor-element-populated">
              <div class="elementor-element elementor-element-7f3a7ab elementor-headline--style-rotate elementor-widget elementor-widget-animated-headline" data-id="7f3a7ab" data-element_type="widget" data-e-type="widget" data-settings="{'headline_style':'rotate','animation_type':'wave','rotating_text':'Innovate.\nSucceed.','loop':'yes','rotate_iteration_delay':2500}" data-widget_type="animated-headline.default">
                <div class="elementor-widget-container">
                  <div class="elementor-headline elementor-headline-animation-type-wave elementor-headline-letters">
                    <div class="elementor-headline-plain-text elementor-headline-text-wrapper" :style="image.titleStyles">{{ image.title }}<br></div>
                    <p class="elementor-headline-plain-text elementor-headline-text-wrapper elementor-headline-text-desc" :style="image.descriptionsStyles" v-html="image.descriptions"></p>
                  </div>
                </div>
              </div>
              <div v-if="image.targetUrl !== null" class="vamtam-has-theme-widget-styles elementor-element elementor-element-1d8dcff vamtam-has-underline-anim elementor-widget elementor-widget-button" data-id="1d8dcff" data-element_type="widget" data-e-type="widget" data-widget_type="button.default">
                <div class="elementor-widget-container">
                  <div class="elementor-button-wrapper">
                    <a :class="image.buttonSize === null ? `elementor-button elementor-button-link elementor-size-sm` : `elementor-button elementor-button-link elementor-size-${image.buttonSize}`" :style="image.buttonStyles" :href="image.targetUrl">
                      <span class="elementor-button-content-wrapper">
                        <span class="elementor-button-text">{{ image.buttonTitle || "More"}}</span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-25bb8b4 elementor-hidden-mobile" data-id="25bb8b4" data-element_type="column" data-e-type="column">
            <div class="elementor-widget-wrap"></div>
          </div>
        </div>
      </section>
      <!-- <div class="title-banner">{{ image.name }}</div>
      <div class="desc-banner">{{ image.name }}</div> -->
    </SplideSlide>
  </Splide>
</template>

<script>
  import { Splide, SplideSlide } from '@splidejs/vue-splide';
  import '@splidejs/vue-splide/css';
  import { ref, onMounted } from 'vue'
  import { useHomeContentStore } from '@/stores/homeContentStore'

  export default {
    name: 'BannerSectionComponent',
    setup() {
      const splideRef = ref(null);
      const homeContentStore = useHomeContentStore()
      const slideOptions = {
        type: 'slide',
        autoplay: true,
        interval: 5000,
        pagination: false,
        arrows: false,
        cover: true,
        heightRatio : 0.5,
        pauseOnHover: false,
        pauseOnFocus: false,
        rewind: true,
      };

      const onSplideMounted = (splide) => {
        splide.Components.Autoplay.play();
      };

      onMounted(async () => {
        await homeContentStore.fetchContentPage()
        splideRef.value?.splide?.Components?.Autoplay?.play();
      })

      return {
        splideRef,
        onSplideMounted,
        slideOptions: slideOptions,
        homeContentStore
      }
    },
    data() {
      return{
      }
    },
    components: {
      Splide, 
      SplideSlide,
    },
  }
</script>
<style>
  .elementor-kit-5 {
    --e-global-typography-03f1db1-font-size: 40px;
    --e-global-typography-03f1db1-line-height: 60px;
  }
</style>
<style scoped>
  .elementor-1905 .elementor-element.elementor-element-5174a02:not(.elementor-motion-effects-element-type-background), .elementor-1905 .elementor-element.elementor-element-5174a02 > .elementor-motion-effects-container > .elementor-motion-effects-layer {
    background-image: none;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .elementor-1905 .elementor-element.elementor-element-7f3a7ab .elementor-headline {
    line-height: 30px;
  }
  .elementor-1905 .elementor-element.elementor-element-7f3a7ab .elementor-headline-plain-text {
    font-size: 20px;
    /* background-color: #fff;
    color: #006940; */
    background-color: rgba(0,0,0,0.5);
    color: #fff;
    padding: 0px 5px;
    line-height: 30px;
  }
  .elementor-1905 .elementor-element.elementor-element-7f3a7ab .elementor-headline-plain-text.elementor-headline-text-desc {
    font-size: 14px;
    font-weight: 500;
    /* background-color: #fff;
    color: #006940; */
    background-color: rgba(0,0,0,0.5);
    color: #fff;
    padding: 5px;
    line-height: 16px;
  }
  .elementor-1905 .elementor-element.elementor-element-6c28eaf .elementor-button:hover, .elementor-1905 .elementor-element.elementor-element-6c28eaf .elementor-button:focus {
    color: #006940;
  }
  .elementor-1905 .elementor-element.elementor-element-5174a02 > .elementor-container > .elementor-column > .elementor-widget-wrap {
    align-content: flex-start !important;
    align-items: flex-start !important;
    margin-top: 80px;
    padding-block-end: 20px;
  }
</style>